import React from "react";
// import Avatar from '@material-ui/core/Avatar';
import Button from "@material-ui/core/Button";
// import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
// import Box from '@material-ui/core/Box';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
// import Container from '@material-ui/core/Container';
// import { Link} from "react-router-dom";
import AppBar from "../../header/index";
// import SignInButton from "../../button/globleButtons";
import AppProvider from "./../../bootstrap/index";
import Card from "@material-ui/core/Card";
// import CardActions from '@material-ui/core/CardActions';
import CardContent from "@material-ui/core/CardContent";
// import CardMedia from '@material-ui/core/CardMedia';
// import Typography from '@material-ui/core/Typography';
import ButtonBase from "@material-ui/core/ButtonBase";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  formControl: {
    margin: theme.spacing(1),
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: 15,
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(5),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  TextField: {
    marginTop: "8%",
    backgroundColor: "#ffffff",
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "center",
    marginTop: "20%",
    // alignItems: "center",
    // paddingLeft:"4%",
    paddingRight: "4%",
    // paddingTop:"30px",
    width: "100%",
    // paddingBottom:"20px",
  },
  Card: {
    height: "9%",
    // width:"30%",
    marginTop: "2%",
    // boxShadow:"none",
    borderRadius: "0px",
    // marginBottom:"10%"
  },
  Card1: {
    height: "100%",
    width: "100%",
  },
  Card2: {
    // marginLeft:"5%",
    // marginRight:"70%"
    float: "left",
  },
  Card3: {
    // marginRight:"50%"
    float: "left",
  },
}));

// const expand=()=>{
//   return(
//     <div>
//       <Typography>adfgggg</Typography>
//     </div>
//   )
// }

const ConsulationType = (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState("female");
  // const {
  //   handleSubmit,
  // } = props;

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <div className={classes.coverBackgroundContainer}>
      <Container component="main" maxWidth="xs" style={{ width: "100%" }}>
        <Typography component="h6" variant="h6" style={{ textAlign: "center" }}>
          Choose Consultation Type
        </Typography>

        <AppProvider>
          {/* <Container
        component="main"
        maxWidth="xs"
        style={{ background: "#ffffff", marginTop: "15%",marginBottom:"20%"}}
      > */}
          <AppBar />
          <FormControl
            component="fieldset"
            className={classes.formControl}
            fullWidth
          >
            <RadioGroup
              aria-label="gender"
              name="gender1"
              value={value}
              onChange={handleChange}
            >
              <Card
                className={classes.Card}
                style={{ width: "100%", marginTop: "5%" }}
              >
                <ButtonBase className={classes.Card1} onClick={() => {}}>
                  <Grid container>
                    <Grid item xs={8}>
                      <CardContent className={classes.Card2}>
                        Personal
                      </CardContent>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel value="1" control={<Radio />} />
                    </Grid>
                  </Grid>
                </ButtonBase>
              </Card>
              <Card
                className={classes.Card}
                style={{ width: "100%", marginTop: "5%" }}
              >
                <ButtonBase className={classes.Card1}>
                  <Grid container>
                    <Grid item xs={8}>
                      <CardContent className={classes.Card3}>
                        Group(2-5)
                      </CardContent>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel value="2" control={<Radio />} />
                    </Grid>
                  </Grid>
                </ButtonBase>
              </Card>
              <Card
                className={classes.Card}
                style={{ width: "100%", marginTop: "6%" }}
              >
                <ButtonBase className={classes.Card1}>
                  <Grid container>
                    <Grid item xs={8}>
                      <CardContent className={classes.Card3}>
                        Group(5-9)
                      </CardContent>
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel value="3" control={<Radio />} />
                    </Grid>
                  </Grid>
                </ButtonBase>
              </Card>
            </RadioGroup>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              onSubmit={() => {}}
              style={{ marginTop: "70%" }}
              // className={buttonClassname}
            >
              Submit Details
            </Button>
          </FormControl>
        </AppProvider>
      </Container>
    </div>
  );
};

export default ConsulationType;
